import { getValueFromPartnerCookie } from '@ecomm/shared-cookies'

export const usePartnerName = () => {
  return getValueFromPartnerCookie('partnerName')
}
